export const sanitizeStringToRegex = (str = '') => new RegExp(str.slice(1, -1))
